(function () {
  'use strict';
  var app = window.Patirti = window.Patirti || {};
  var config = window.PatirtiConfig || {};
  var strings = config.strings || {};
  var key = 'patirti_wishlist';
  var legacyKey = 'tm_wishlist';
  var migratedKey = 'patirti_wishlist_migrated';
  var buttonSelector = '[data-wishlist-toggle]';
  var entries = [];
  var syncTimer = null;
  var resolving = {};

  function read(storageKey) {
    try { return JSON.parse(window.localStorage.getItem(storageKey) || '[]'); } catch (_) { return []; }
  }
  function normalize(list) {
    if (!Array.isArray(list)) return [];
    return list.reduce(function (result, item) {
      var raw = typeof item === 'string' ? { handle: item } : item;
      if (!raw || typeof raw !== 'object') return result;
      var id = /^\d+$/.test(String(raw.id || '')) ? String(raw.id) : null;
      var handle = typeof raw.handle === 'string' ? raw.handle.trim() : '';
      if (!/^[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(handle)) return result;
      if (!result.some(function (entry) { return entry.handle === handle || (id && entry.id === id); })) result.push({ id: id, handle: handle });
      return result;
    }, []);
  }
  function save() {
    try { window.localStorage.setItem(key, JSON.stringify(entries)); return true; } catch (_) { return false; }
  }
  function list() {
    return entries.map(function (item) { return { id: item.id, handle: item.handle }; });
  }
  function has(id, handle) {
    return entries.some(function (item) {
      return (id != null && item.id === String(id)) || item.handle === handle || item.handle === String(id);
    });
  }
  function sync() {
    var changed = false;
    document.querySelectorAll(buttonSelector).forEach(function (button) {
      var id = button.dataset.productId;
      var handle = button.dataset.productHandle;
      var active = has(id, handle);
      if (active && /^\d+$/.test(id || '')) entries.forEach(function (item) {
        if (item.handle === handle && item.id !== id) { item.id = id; changed = true; }
      });
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active
        ? (strings.wishlistRemove || 'Favorilerden çıkar')
        : (strings.wishlistAdd || 'Favorilere ekle'));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (counter) {
      if (counter.textContent !== String(entries.length)) counter.textContent = String(entries.length);
      counter.hidden = !entries.length;
    });
    if (changed) save();
  }
  function announce() {
    var detail = { items: list(), count: entries.length };
    if (app.events) app.events.dispatchEvent(new CustomEvent('wishlist:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: detail }));
  }
  function toggle(id, handle) {
    if (config.wishlistEnabled === false) return false;
    if (id && typeof id === 'object') { handle = id.handle; id = id.id; }
    var existing = entries.findIndex(function (item) {
      return (id != null && item.id === String(id)) || item.handle === handle || item.handle === String(id);
    });
    if (existing >= 0) entries.splice(existing, 1);
    else {
      var next = normalize([{ id: id, handle: handle }]);
      if (!next.length) return false;
      entries.push(next[0]);
    }
    save();
    sync();
    announce();
    return existing < 0;
  }
  function resolveLegacyIds() {
    var pending = entries.filter(function (item) { return !item.id && !resolving[item.handle]; });
    var root = (config.routes && config.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    function next() {
      var item = pending.shift();
      if (!item) return Promise.resolve();
      resolving[item.handle] = true;
      return fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (product) {
          if (!/^\d+$/.test(String(product.id || ''))) return;
          entries.forEach(function (entry) { if (entry.handle === item.handle) entry.id = String(product.id); });
          save();
          sync();
          announce();
        }).catch(function () { /* Preserve a legacy favourite even while offline. */ })
        .then(next);
    }
    return Promise.all([next(), next(), next(), next()]);
  }
  app.wishlist = { has: has, toggle: toggle, list: list, sync: sync };
  function init() {
    entries = normalize(read(key));
    var legacy = normalize(read(legacyKey));
    var migrated = false;
    try { migrated = window.localStorage.getItem(migratedKey) === '1'; } catch (_) { /* Storage unavailable. */ }
    // Eski temanın listesi silinmez (eski temaya dönüş/A-B testi için); bir kez aktarılır.
    if (legacy.length && !migrated) {
      entries = normalize(entries.concat(legacy));
      if (save()) {
        try { window.localStorage.setItem(migratedKey, '1'); } catch (_) { /* Retry migration next visit. */ }
      }
    }
    sync();
    resolveLegacyIds();
    document.addEventListener('click', function (event) {
      var button = event.target.closest(buttonSelector);
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      toggle(button.dataset.productId, button.dataset.productHandle);
    });
    window.addEventListener('storage', function (event) {
      if (event.key === key || event.key === null) {
        entries = normalize(read(key));
        sync();
        announce();
      }
    });
    new MutationObserver(function (records) {
      var hasControls = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(buttonSelector + ',[data-wishlist-count]') || node.querySelector(buttonSelector + ',[data-wishlist-count]'));
        });
      });
      if (hasControls) {
        window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(sync, 30);
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
